import { useManfredite } from 'hooks/api/manfredite';
import { usePageTrack } from 'hooks/usePageTrack';
import { useRouter } from 'next/router';
import { useCallback, useMemo } from 'react';
import ServiceEventTracking from 'services/service.event-tracking';
import { APP_URLS, getAppUrl } from 'utils/app-urls';

// Custom hook.
// -----------------------------------------------------------------------------
export const useMandecar = () => {
  // Hooks.
  // ---------------------------------------------------------------------------
  const { locale } = useRouter();
  const { manfredite } = useManfredite();

  usePageTrack('Landing - Page Loaded');

  // Variables.
  // ---------------------------------------------------------------------------
  const urlCTA = useMemo(
    () =>
      manfredite
        ? getAppUrl(APP_URLS.portalV2Dashboard, locale)
        : `${getAppUrl(
            APP_URLS.join,
            locale
          )}?locale=${locale}&source=mandecar-23`,
    [locale, manfredite]
  );

  // Functions.
  // ---------------------------------------------------------------------------
  const handleOnClickCTA = useCallback(
    (event) => {
      ServiceEventTracking.trackExternalLandingCtaClicked(
        event,
        urlCTA,
        'mandecar-carrera'
      );
    },
    [urlCTA]
  );

  // Return.
  // ---------------------------------------------------------------------------
  return {
    onClickCTA: handleOnClickCTA,
    urlCTA
  };
};
